var app = angular.module('leonardo');

var FormLevels = function(LevelService, $q, $timeout, $rootScope, FilterService, CountryService, AuthDataService) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '=',
      multiple: '=',
      filter: '@',
      name: '@'
    },
    templateUrl: 'views/templates/form/form-levels.html',
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];
      scope.formCtrl = scope.$parent.Form ? scope.$parent.Form : { '$submitted' : true };
      scope.currentCountry = AuthDataService.authData.account ? AuthDataService.authData.account.country : null;
      scope.levelService = LevelService;
      scope.name = scope.name ? scope.name : 'value';
      scope.mode = scope.multiple ? 'array' : '';

      scope.data = {};

      scope.initValues = false;

      scope.initialized = false;

      scope.promises = [];

      scope.isEmpty = isEmpty;

      scope.setLabelLevels = function (country) {
        scope.labelState = (country && country.level_1_label) ? country.level_1_label : 'State';
        scope.labelCounty = (country && country.level_2_label) ? country.level_2_label : 'County';
        scope.labelCity = (country && country.level_3_label) ? country.level_3_label : 'City';
        if (country && country.level_4_label) {
          scope.labelZip = (country.level_4_label == 'Zipcode') ? 'ZIP Code' : country.level_4_label;
        }
        else {
          scope.labelZip = 'ZIP Code';
        }
      };

      scope.setLevels = function() {
        var levels = [];
        angular.forEach(scope.data, function (data, key) {
          if (data && (key !== 'country')) {
            if (angular.isArray(data)) {
              angular.forEach(data, function(level) {
                levels.push(level);
              });
            }
            else {
              levels.push(data);
            }
          }
        });
        return levels;
      };

      scope.getParents = function(parents) {
        return angular.isArray(parents) ? parents.join(',') : parents;
      };

      scope.initData = function() {
        var value = null;
        var levels = [];
        if (angular.isObject(scope.value)) {
          value = scope.value;
          if (isEmpty(scope.value.country) && scope.currentCountry) {
            scope.value.country = scope.currentCountry.id || scope.currentCountry;
          }
        }
        else {
          if (!isNull(scope.value)) {
            levels = !angular.isArray(scope.value) ? scope.value.split(',') : scope.value;
            value = {
              country: scope.currentCountry ? (scope.currentCountry.id || scope.currentCountry) : null
            };
          }
          else if (scope.filter) {
            levels = FilterService.hasFilter(scope.filter) ? FilterService.getFilter(scope.filter).split(',') : [];
            value = {
              country: null
            };
            if (FilterService.hasFilter('country')) {
              value.country = FilterService.getFilter('country');
            }
            else {
              value.country = scope.currentCountry ? (scope.currentCountry.id || scope.currentCountry) : null;
            }
          }
          angular.forEach(levels, function(level, index) {
            switch (index) {
              case 0:
                value.state = level;
                break;
              case 1:
                value.county = level;
                break;
              case 2:
                value.city = level;
                break;
              case 3:
                value.zipcode = level;
                break;
            }
          });
        }
        if (value) {
          scope.data = value;
          $timeout(function () {
            $q.all(scope.promises).then(function () {
              scope.initialized = true;
            });
          }, 10);
        }
      };

      scope.onCountryChange = function() {
        if (!isEmpty(scope.data.country)) {
          CountryService.get(scope.data.country, true).then(function (data) {
            scope.setLabelLevels(data);
            scope.currentCountryCode = (data && data.code || '').toLowerCase();
          });
        }
        if (scope.initialized) {
          scope.data.state = scope.multiple ? [] : null;
          scope.data.county = scope.multiple ? [] : null;
          scope.data.city = scope.multiple ? [] : null;
          scope.data.zipcode = scope.multiple ? [] : null;
          scope.ngModelCtrl.$setViewValue(scope.data);
          scope.ngModelCtrl.$validate();
          if (scope.filter) {
            FilterService.removeFilter(scope.filter);
            FilterService.setFilter('country', scope.getParents(scope.data.country));
          }
        }
        else {
          var defer = $q.defer();
          scope.promises.push(defer);
          scope.$on('select-multiple:initialized', function (event, name) {
            if (name === 'country') {
              defer.resolve();
            }
          });
        }
      };
    
      scope.onStateChange = function() {
        if (scope.initialized) {
          scope.data.county = scope.multiple ? [] : null;
          scope.data.city = scope.multiple ? [] : null;
          scope.data.zipcode = scope.multiple ? [] : null;
          $rootScope.$broadcast('address-level:updated', 'state', scope.data.state);
          scope.ngModelCtrl.$setViewValue(scope.data);
          scope.ngModelCtrl.$validate();
          if (scope.filter) {
            FilterService.setFilter(scope.filter, scope.setLevels().join(','));
          }
        }
        else {
          var defer = $q.defer();
          scope.promises.push(defer);
          scope.$on('select-multiple:initialized', function (event, name) {
            if (name === 'state') {
              defer.resolve();
            }
          });
        }
      };
    
      scope.onCountyChange = function() {
        if (scope.initialized) {
          scope.data.city = scope.multiple ? [] : null;
          scope.data.zipcode = scope.multiple ? [] : null;
          $rootScope.$broadcast('address-level:updated', 'county', scope.data.county);
          scope.ngModelCtrl.$setViewValue(scope.data);
          scope.ngModelCtrl.$validate();
          if (scope.filter) {
            FilterService.setFilter(scope.filter, scope.setLevels().join(','));
          }
        }
        else {
          var defer = $q.defer();
          scope.promises.push(defer);
          scope.$on('select-multiple:initialized', function (event, name) {
            if (name === 'county') {
              defer.resolve();
            }
          });
        }
      };
    
      scope.onCityChange = function() {
        if (scope.initialized) {
          scope.data.zipcode = scope.multiple ? [] : null;
          $rootScope.$broadcast('address-level:updated', 'city', scope.data.city);
          scope.ngModelCtrl.$setViewValue(scope.data);
          scope.ngModelCtrl.$validate();
          if (scope.filter) {
            FilterService.setFilter(scope.filter, scope.setLevels().join(','));
          }
        }
        else {
          var defer = $q.defer();
          scope.promises.push(defer);
          scope.$on('select-multiple:initialized', function (event, name) {
            if (name === 'city') {
              defer.resolve();
            }
          });
        }
      };
    
      scope.onZipChange = function() {
        if (scope.initialized) {
          $rootScope.$broadcast('address-level:updated', 'zipcode', scope.data.zipcode);
          scope.ngModelCtrl.$setViewValue(scope.data);
          scope.ngModelCtrl.$validate();
          if (scope.filter) {
            FilterService.setFilter(scope.filter, scope.setLevels().join(','));
          }
        }
        else {
          var defer = $q.defer();
          scope.promises.push(defer);
          scope.$on('select-multiple:initialized', function (event, name) {
            if (name === 'zipcode') {
              defer.resolve();
            }
          });
        }
      };

      scope.getRealValue = function (value) {
        if (angular.isArray(value)) {
          return value.map(item => item ? item.toString() : null);
        }
        return (value ? value.toString() : value);
      };

      scope.$watch('data.country', function (newVal, oldVal) {
        if (!angular.equals(scope.getRealValue(newVal), scope.getRealValue(oldVal))) {
          scope.onCountryChange();
        }
      });

      scope.$watch('data.state', function (newVal, oldVal) {
        if (!angular.equals(scope.getRealValue(newVal), scope.getRealValue(oldVal))) {
          scope.onStateChange();
        }
      });

      scope.$watch('data.county', function (newVal, oldVal) {
        if (!angular.equals(scope.getRealValue(newVal), scope.getRealValue(oldVal))) {
          scope.onCountyChange();
        }
      });

      scope.$watch('data.city', function (newVal, oldVal) {
        if (!angular.equals(scope.getRealValue(newVal), scope.getRealValue(oldVal))) {
          scope.onCityChange();
        }
      });

      scope.$watch('data.zipcode', function (newVal, oldVal) {
        if (!angular.equals(scope.getRealValue(newVal), scope.getRealValue(oldVal))) {
          scope.onZipChange();
        }
      });

      scope.setLabelLevels(scope.currentCountry);

      scope.ngModelCtrl.$render = function() {
        scope.value = scope.ngModelCtrl.$modelValue;
        CountryService.getlist({
          disable_pagination: true,
          essential: true,
        }).then(function (data) {
          scope.countries = data.results ? data.results : data;
          if (!scope.initialized) {
            $timeout(scope.initData, 0);
          }
        });
      };

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        if(modelValue) {
          return scope.multiple ? !isEmpty(modelValue.zipcode) : !isNull(modelValue.zipcode);
        }
        else {
          return false;
        }
      };

    }
  };
};

app.directive('formLevels', ['LevelService', '$q', '$timeout', '$rootScope', 'FilterService', 'CountryService',
  'AuthDataService', FormLevels]);
